import L from 'leaflet';

interface PopupOffsetResult {
  offset: [number, number];
  className: string;
}

const calculatePopupOffset = (
  marker: L.Marker,
  map: L.Map,
): PopupOffsetResult => {
  const markerLatLng = marker.getLatLng();
  const markerPoint = map.latLngToContainerPoint(markerLatLng);
  const mapSize = map.getSize();

  const POPUP_WIDTH = 265;
  const POPUP_HEIGHT = 210;
  const FIXED_HORIZONTAL_OFFSET = 110; // Half of popup width for centering
  const VERTICAL_MARGIN = 20; // Minimum distance from top edge

  let offsetX = 0;
  let offsetY = -55; // Default: popup above marker
  let className = 'leaflet-hover-popup';

  const halfWidth = POPUP_WIDTH / 2;
  const margin = 10;

  // Check if popup would go beyond left edge
  if (markerPoint.x - halfWidth < margin) {
    offsetX = FIXED_HORIZONTAL_OFFSET;
    className += ' popup-offset-left';
  }
  // Check if popup would go beyond right edge
  else if (markerPoint.x + halfWidth > mapSize.x - margin) {
    offsetX = -FIXED_HORIZONTAL_OFFSET;
    className += ' popup-offset-right';
  }

  // Check vertical position - if too close to top, show below
  if (markerPoint.y - POPUP_HEIGHT - 55 < VERTICAL_MARGIN) {
    offsetY = 230; // Show popup below marker
    className += ' popup-bottom';
  }

  return { offset: [offsetX, offsetY], className };
};

export default calculatePopupOffset;
